import { dailyDevo } from "@/data/brand";

export const AuthBrand = () => (
  <div className="mb-10 flex items-center gap-3" data-testid="auth-brand-block">
    <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-white shadow-[0_6px_18px_rgba(26,54,38,0.12)]" data-testid="auth-brand-icon">
      <img src={dailyDevo.logoUrl} alt="DailyDevo logo" className="h-full w-full object-cover" data-testid="auth-dailydevo-logo" />
    </span>
    <div>
      <p className="font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid="auth-brand-title">Fruitful</p>
      <p className="text-sm text-[#8C9B90]" data-testid="auth-brand-subtitle">By dailydevo.ca</p>
    </div>
  </div>
);